export default {
    components: {
      itemCard: () => import("@/modules/base/components/delivery/itemCard.vue"),
    },
    computed: {

    },
  }